import type { ComponentProps } from "react";
import { useParams } from "react-router";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { ProspectWorkspace } from "@/components/admin/prospect-workspace";
import { useView, usePageTitle } from "@shared/client/view";

type ProspectData = ComponentProps<typeof ProspectWorkspace>;

export default function AdminProspectPage() {
  usePageTitle("Prospect — Administration Hune");
  const { id = "" } = useParams();
  const { data, error } = useView<ProspectData>(`/api/views/admin/prospection/${encodeURIComponent(id)}`);
  if (error) return <AdminDataNotice error={error} />;
  if (!data) return null;
  return <ProspectWorkspace prospect={data.prospect} />;
}
